/**
 * Shared definition for the post-checkout "How did you hear about Beast Academy?"
 * survey. Used by checkout UI copy and store API validation.
 */

const HEAR_ABOUT_BA_SURVEY_KEY = "hear_about_ba";

const HEAR_ABOUT_BA_SURVEY_TITLE = "How did you hear about Beast Academy?";

const HEAR_ABOUT_BA_SURVEY_OPTIONS = [
	{key: "search", label: "Search (Google, Bing)"},
	{key: "ai_result", label: "AI result (ChatGPT, Gemini, Claude)"},
	{key: "friend_or_family", label: "Friend or family"},
	{key: "teacher_or_school", label: "Teacher or school"},
	{key: "advertisement", label: "Advertisement"},
	{key: "social_media", label: "Social (Reddit, Facebook, TikTok)"},
	{key: "other", label: "Other"},
];

const HEAR_ABOUT_BA_SURVEY_OPTION_KEYS = HEAR_ABOUT_BA_SURVEY_OPTIONS.map(
	option => option.key
);

const isValidHearAboutBaSurveyOptionKey = function(optionKey) {
	return HEAR_ABOUT_BA_SURVEY_OPTION_KEYS.indexOf(optionKey) !== -1;
};

module.exports = {
	HEAR_ABOUT_BA_SURVEY_KEY,
	HEAR_ABOUT_BA_SURVEY_TITLE,
	HEAR_ABOUT_BA_SURVEY_OPTIONS,
	HEAR_ABOUT_BA_SURVEY_OPTION_KEYS,
	isValidHearAboutBaSurveyOptionKey,
};
